import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import AppConfigService from 'app/core/app-config.service';

@Injectable({ providedIn: 'root' })
export default class PasswordResetInitService {
  constructor(private http: HttpClient) {}

  save(mail: any): Observable<any> {
    return this.http.post(`${AppConfigService.envConfig.fssServicesBaseUrl}api/rx/rxProfile/forgotPassword`, mail);
  }
}
